<template>
  <footer class="footer">
    <div class="wrapper">
      <div class="footer__left">
        <a href="/" class="footer__logo" aria-label="link to main page">
          <img src="@/images/logo-white.svg" alt="logo" />
        </a>
        <!-- <router-link to="/" class="footer__logo" aria-label="link to main page">
          <img src="@/images/logo-white.svg" alt="logo" />
        </router-link> -->
        <div class="footer__copyright">
          <span>Made by <a class="footer__copyright-link" href="https://karmabot.chat/" target="_blank">Karma</a> team with ❤️</span>
          <span> © {{ currentYear }} All rights reserved.</span>
        </div>
      </div>
      <nav class="footer__navigation">
        <div class="footer__navigation-col">
          <!-- <router-link to="/comparison" class="footer__link">Why Site Palette?</router-link>
          <router-link to="/vs-color" class="footer__link">Site Palette vs. Color Palette</router-link>
          <router-link to="/vs-extract" class="footer__link">Site Palette vs. Extract Colors DevTool</router-link>
          <router-link to="/vs-website" class="footer__link">Site Palette vs. Website Color Palette</router-link> -->
          <a href="/comparison" aria-label="go to comparison page" class="footer__link">Why Site Palette?</a>
          <a href="/vs-color" aria-label="go to comparison page color" class="footer__link">Site Palette vs. Color Palette</a>
          <a href="/vs-extract" aria-label="go to comparison page extract" class="footer__link">Site Palette vs. Extract Colors DevTool</a>
          <a href="/vs-website" aria-label="go to comparison page website" class="footer__link">Site Palette vs. Website Color Palette</a>
        </div>
        <div class="footer__navigation-col">
          <a href="/success-stories" class="footer__link">Success stories</a>
          <a
            v-for="story in successStories"
            :key="story.slug"
            :href="`/success-stories/${story.slug}`"
            class="footer__link"
          >
            {{ story.footerLabel }}
          </a>
        </div>
        <div class="footer__navigation-col">
          <a :href="blogUrl" class="footer__link">Blog</a>
          <!-- <router-link to="/help" class="footer__link">Help</router-link>
          <router-link to="/privacy" class="footer__link">Privacy policy</router-link>
          <router-link to="/tos" class="footer__link">Terms of service</router-link> -->
          <a href="/help" aria-label="go to help page" class="footer__link">Help</a>
          <a href="/privacy" aria-label="go to privacy page" class="footer__link">Privacy policy</a>
          <a href="/tos" aria-label="go to terms and conditions page" class="footer__link">Terms of service</a>
        </div>
      </nav>
    </div>
  </footer>
</template>

<script>
import { successStories } from '@/data/successStories';

export default {
  data() {
    const { origin } = window.location;
    const domain = origin;
    
    return {
      currentYear: new Date().getFullYear(),
      blogUrl: `${domain}/blog/`,
      successStories,
    }
  }
};
</script>

<style scoped>

.footer {
  background: #202629;
  position: relative;
}
.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: stretch;
  padding: 56px 20px;
  width: 100%;
  max-width: 1224px;
  margin: 0 auto;
  height: 248px;
}

.footer__left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.footer__logo {
  width: 198px;
  height: 28px;
}

.footer__navigation {
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 24px;
  align-items: flex-start;
}

.footer__navigation-col{
  display: flex;
  flex-direction: column;
  justify-content: start;
  gap: 24px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.footer__link{
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #fff;
}

.footer__logo:hover, .footer__link:hover {
  opacity: 0.8;
}

.footer__copyright {
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}
.footer__copyright-link{
  border-bottom: 1px solid #fff;
}

.footer__copyright-link:hover {
  opacity: 0.8
}

@media screen and (max-width: 900px) {
  .wrapper {
    flex-direction: column-reverse;
    height: auto;
    gap: 32px;
  }
  .footer__logo {
    margin-bottom: 32px;
  }
  .footer__navigation{
    width: 100%;
    flex-direction: column;
    gap: 42px;
  }
}
@media screen and (max-width: 768px) {
  .wrapper {
    padding: 48px 16px;
  }
}
</style>
